"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldValue = exports.Timestamp = exports.getAppCompat = exports.getApp = exports.setApp = void 0;
const app_1 = __importDefault(require("firebase/compat/app"));
require("firebase/compat/firestore");
require("firebase/compat/storage");
let _app;
function setApp(app) {
    _app = app;
}
exports.setApp = setApp;
function getApp() {
    if (_app === undefined) {
        throw new Error('App is undefined in @ht-lib/accounts-common, call setApp()!');
    }
    return _app;
}
exports.getApp = getApp;
function getAppCompat() {
    var _a;
    return (_a = _app) !== null && _a !== void 0 ? _a : app_1.default.app();
}
exports.getAppCompat = getAppCompat;
exports.Timestamp = app_1.default.firestore.Timestamp;
exports.FieldValue = app_1.default.firestore.FieldValue;
